// import { useEffect, useState } from "react";
// import { useLocation } from "react-router-dom";
// import "./single.scss";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Navbar from "../../components/navbar/Navbar";
// import { Link } from "react-router-dom";
// import { serverUrl } from "../../temp";
// const StudentAttendanceSingle = () => {
//   // Extracting subjectId using regular expressions
//   const location = useLocation();
//   // const subjectId = location.pathname.match(/\/student-attendance\/(\d+)/);
//   const subjectId = location.pathname.match(/\/student-attendance\/(\d+)/)?.[1];

//   const [student_attendance, setStudent_attendance] = useState(null);
//   let [token] = useState(localStorage.getItem("token"));

//   const redirectToLogin = () => {
//     alert("Plaese Login first then you can access this page...");
//     window.location.href = "/"; // Replace "/login" with the actual login page path
//   };

//   const fetchSubject = async () => {
//     try {
//       const response = await fetch(
//         `${serverUrl}/student_attendance/${subjectId}`
//       );
//       // if (!response.ok) {
//       //     throw new Error('Failed to fetch student_attendance');
//       // }
//       const data = await response.json();
//       setStudent_attendance(data);
//       localStorage.setItem("batchData", JSON.stringify(data));
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   useEffect(() => {
//     if (subjectId) {
//       fetchSubject();
//     }
//   }, [subjectId]);

//   return (
//     <>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="single">
//           <Sidebar />
//           <div className="singleContainer">
//             <Navbar />
//             <div className="top">
//               <div className="left">
//                 <h1 className="title">Student Attendance Information</h1>
//                 <div className="details">
//                   <h1 className="itemTitle">
//                     {student_attendance?.data.student_name}
//                   </h1>
//                   <div className="detailItem">
//                     <span className="itemKey">Admin: </span>
//                     <span className="itemValue">
//                       {student_attendance?.data.admin_name}
//                     </span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Teacher: </span>
//                     <span className="itemValue">
//                       {student_attendance?.data.user_name}
//                     </span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Class: </span>
//                     <span className="itemValue">
//                       {student_attendance?.data.class_name}
//                     </span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Subject: </span>
//                     <span className="itemValue">
//                       {student_attendance?.data.subject_name}
//                     </span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Date: </span>
//                     <span className="itemValue">
//                       {student_attendance?.data.attendance_date}
//                     </span>
//                   </div>
//                   {/* <div className="detailItem">
//                                             <span className="itemKey">Center Id: </span>
//                                             <span className="itemValue">{student_attendance?.data.center_id}</span>
//                                         </div> */}
//                   {/* <div className="detailItem">
//                     <span className="itemKey">Subject Name: </span>
//                     <span className="itemValue">{student_attendance?.data.name}</span>
//                   </div> */}
//                   {/* <div className="detailItem">
//                                             <span className="itemKey">Class Name: </span>
//                                             <span className="itemValue">{student_attendance?.data.class_names}</span>
//                                         </div> */}
//                   {/* <div className="detailItem">
//                     <span className="itemKey">User Name: </span>
//                     <span className="itemValue">
//                       {student_attendance?.data.user_names}
//                     </span>
//                   </div> */}
//                   {/* <div className="detailItem">
//                                             <span className="itemKey">Status: </span>
//                                             <span className="itemValue">{student_attendance?.data.status}</span>
//                                         </div> */}
//                 </div>
//               </div>
//             </div>
//             {/* <div className="right">
//                     <Chart aspect={3 / 1} title="student_attendance Spending ( Last 6 Months)" />
//                 </div> */}
//           </div>
//           {/* <div className="bottom">
//                 <h1 className="title">Last Transactions</h1>
//                 <List />
//                 </div> */}
//         </div>
//       )}
//     </>
//   );
// };

// export default StudentAttendanceSingle;
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { serverUrl } from "../../temp";

const StudentAttendanceSingle = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const subjectId = location.pathname.match(/\/student-attendance\/(\d+)/)?.[1];
  const [student_attendance, setStudent_attendance] = useState(null);
  const [token] = useState(localStorage.getItem("token"));
  const [isLoading, setIsLoading] = useState(true);

  const redirectToLogin = () => {
    alert("Please login first to access this page...");
    window.location.href = "/";
  };

  const fetchStudentAttendance = async () => {
    try {
      const response = await fetch(
        `${serverUrl}/student_attendance/${subjectId}`
      );
      const data = await response.json();
      setStudent_attendance(data);
      localStorage.setItem("attendanceData", JSON.stringify(data));
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const getStatusBadge = (status) => {
    const statusMap = {
      0: { color: "bg-red-100 text-red-800", label: "Absent" },
      1: { color: "bg-green-100 text-green-800", label: "Present" },
      2: { color: "bg-yellow-100 text-yellow-800", label: "Late" },
      3: { color: "bg-blue-100 text-blue-800", label: "Leave" },
      4: { color: "bg-purple-100 text-purple-800", label: "Half Leave" },
    };

    const statusInfo = statusMap[status] || statusMap[0];
    return (
      <span
        className={`px-3 py-1 rounded-full text-xs font-medium ${statusInfo.color}`}
      >
        {statusInfo.label}
      </span>
    );
  };

  useEffect(() => {
    if (subjectId) {
      fetchStudentAttendance();
    }
  }, [subjectId]);

  if (!token) {
    redirectToLogin();
    return null;
  }

  return (
    <div className="single">
      <Sidebar />
      <div className="singleContainer">
        <Navbar />
        <div className="top">
          <div className="left">
            <div className="flex justify-between items-center mb-4">
              <button
                onClick={() => navigate(-1)}
                className="px-3 py-1 text-sm bg-purple-100 text-purple-800 rounded-lg hover:bg-purple-200 transition-all border border-purple-200 flex items-center gap-1 shadow-sm hover:shadow-md"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 19l-7-7m0 0l7-7m-7 7h18"
                  />
                </svg>
                Back
              </button>
              <h1 className="title flex-1 text-center">
                Student Attendance Information
              </h1>
              <div className="w-20"></div>
            </div>

            {isLoading ? (
              <div className="flex justify-center items-center h-64">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500"></div>
              </div>
            ) : (
              <div className="space-y-6">
                {/* Attendance Header */}
                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <div className="flex flex-col md:flex-row gap-6 items-center md:items-start">
                    {/* Student Icon */}
                    <div className="flex-shrink-0">
                      <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-purple-100 flex items-center justify-center">
                        <span className="text-2xl md:text-3xl text-purple-600">
                          {student_attendance?.data.student_name
                            ?.charAt(0)
                            .toUpperCase()}
                        </span>
                      </div>
                    </div>

                    {/* Student Info */}
                    <div className="flex-1 text-center md:text-left">
                      <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-3">
                        <h1 className="text-2xl font-bold text-gray-800">
                          {student_attendance?.data.student_name}
                        </h1>
                        {student_attendance?.data.status !== undefined &&
                          getStatusBadge(student_attendance.data.status)}
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                        {student_attendance?.data.attendance_date && (
                          <div className="bg-gray-50 rounded-lg p-3">
                            <span className="text-gray-500 block">Date:</span>
                            <span className="font-medium">
                              {student_attendance.data.attendance_date}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Attendance Details */}
                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <h3 className="text-lg font-medium text-gray-800 mb-4 border-b pb-2">
                    Attendance Details
                  </h3>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Left Column */}
                    <div className="space-y-4">
                      {student_attendance?.data.class_name && (
                        <div>
                          <label className="block text-sm text-gray-500 mb-2">
                            Class
                          </label>
                          <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                            {student_attendance.data.class_name}
                          </p>
                        </div>
                      )}

                      {student_attendance?.data.subject_name && (
                        <div>
                          <label className="block text-sm text-gray-500 mb-2">
                            Subject
                          </label>
                          <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                            {student_attendance.data.subject_name}
                          </p>
                        </div>
                      )}
                    </div>

                    {/* Right Column */}
                    <div className="space-y-4">
                      {student_attendance?.data.user_name && (
                        <div>
                          <label className="block text-sm text-gray-500 mb-2">
                            Teacher
                          </label>
                          <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                            {student_attendance.data.user_name}
                          </p>
                        </div>
                      )}

                      {student_attendance?.data.admin_name && (
                        <div>
                          <label className="block text-sm text-gray-500 mb-2">
                            Admin
                          </label>
                          <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                            {student_attendance.data.admin_name}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentAttendanceSingle;
